import React from 'react';
import { Menubar } from 'primereact/menubar';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { deleteToken, selectUserData } from '@reduxSlices/user/userSlices';

import './styles.scss';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector(selectUserData);
  const { role } = userData;
  const items = [
    {
      label: 'Прийомка',
      icon: 'pi pi-fw pi-truck',
      className: pathname === '/receiving' ? 'active-menu' : '',
      disabled: pathname === '/receiving',
      command: () => navigate('/receiving'),
    },
    {
      label: 'Продукти',
      icon: 'pi pi-fw pi-inbox',
      className: pathname === '/products' ? 'active-menu' : '',
      disabled: pathname === '/products',
      command: () => navigate('/products'),
    },
    ...(['admin'].includes(role)
      ? [
          {
            label: 'Підприємства',
            icon: 'pi pi-fw pi-box',
            className: pathname === '/company' ? 'active-menu' : '',
            disabled: pathname === '/company',
            command: () => navigate('/company'),
          },
        ]
      : []),

    ...(['admin', 'manager'].includes(role)
      ? [
          {
            label: 'Довідники',
            icon: 'pi pi-fw pi-book',
            className: pathname === '/catalogs' ? 'active-menu' : '',
            disabled: pathname === '/catalogs',
            command: () => navigate('/catalogs'),
          },
        ]
      : []),

    ...(['admin', 'manager'].includes(role)
      ? [
          {
            label: 'Користувачі',
            icon: 'pi pi-fw pi-user',
            className: pathname === '/users' ? 'active-menu' : '',
            disabled: pathname === '/users',
            command: () => navigate('/users'),
          },
        ]
      : []),
    {
      label: 'Вихід',
      icon: 'pi pi-fw pi-power-off',
      command: () => {
        dispatch(deleteToken());
      },
      url: '/login',
    },
  ];
  const Logo = () => {
    return (
      <Link className='layout__logo' to={'/'}>
        <img src='/images/logo.svg' alt='logo' className='layout__logo-img' />
      </Link>
    );
  };
  return (
    <div className='layout'>
      <div className='layout__menu'>
        <Menubar model={items} start={Logo} />
      </div>
      <div className='layout__content'>{children}</div>
    </div>
  );
};

export default Layout;
